import { GlobalAxios } from "../axios/axios-config";
import { IInsuranceRegisterCategory } from "../models/insurance-register-category";

const INSURANCE_REGISTER_CATEGORY_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/InsuranceRegisterCategory/InsuranceRegisterCategory";

export const insuranceRegisterCategoryList = (params?: any) => {
  return GlobalAxios.get<IInsuranceRegisterCategory[]>(
    INSURANCE_REGISTER_CATEGORY_ROUTE,
    {
      params: params,
      paramsSerializer: {
        indexes: null,
      },
    },
  );
};
